import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { emailregex } from '../../helpers/helpers'
import { TranslationPipe } from '../../pipes/translation/translation.pipe'
import { AuthService } from '../../services/auth.service'
import { GeneralService } from '../../services/general.service'
import { RequestService } from '../../services/request.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [TranslationPipe],
})
export class LoginComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription()
  user: any
  loginForm: FormGroup
  get f() {
    return this.loginForm.controls
  }
  loginState = 'login'
  changePasswordError: string
  disableButton: boolean
  magicLinkErr: string
  blueSectionState = 'login'
  sent = false
  emailError = false
  passwordError = false
  emailSent = ''
  redirectUrl: string

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private gs: GeneralService,
    public translate: TranslationPipe,
    private rs: RequestService,
    public translation: TranslationPipe,
  ) {
    this.gs.setWindow({ state: false })
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(emailregex)]],
      password: [null, [Validators.required]],
    })

    this.subscription.add(
      this.loginForm.controls.email.valueChanges.subscribe(() => {
        this.emailError = false
      }),
    )

    this.subscription.add(
      this.loginForm.controls.password.valueChanges.subscribe(() => {
        this.passwordError = false
      }),
    )

    this.subscription.add(
      this.route.queryParams.subscribe((params) => {
        this.redirectUrl = params['redirect']
      }),
    )
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  changeLoginState(state) {
    this.disableButton = false
    this.loginState = state
    this.blueSectionState = 'login'
    this.sent = false
    this.emailSent = ''
  }

  login() {
    if (this.loginForm.invalid) {
      this.emailError = this.f.email.errors ? true : false
      this.passwordError = this.f.password.errors ? true : false
      return
    }

    this.gs.logScreenEvents(
      'session_login',
      'session_login',
      'session_login',
      'click',
    )

    this.disableButton = true
    this.gs.setSpinnerState({ show: true })
    this.user = this.loginForm.value
    this.subscription.add(
      this.authService.login(this.user).subscribe(
        async () => {
          const admin = await this.gs.asyncRequest(this.authService.getAdmin())
          localStorage.setItem('LANG', admin['lang'])
          this.emailError = false
          this.passwordError = false
          this.gs.setSpinnerState({ show: false })

          if (this.redirectUrl) {
            this.router.navigate(['home', this.redirectUrl])
            return
          }

          this.router.navigate(['home'])
        },
        (err) => {
          if (err.status === 401) {
            this.gs.openAlert({ msg: 'PASSWORD_USER_INCORRECT', error: true })
            this.disableButton = false
            this.gs.setSpinnerState({ show: false })
          } else {
            this.gs.openAlert({ msg: 'ERROR', error: true })
            this.disableButton = false
            this.gs.setSpinnerState({ show: false })
          }
        },
      ),
    )
  }

  async changePassword() {
    if (this.loginForm.controls.email.invalid) {
      this.emailError = this.f.email.errors ? true : false
      return this.gs.openAlert({ msg: 'ERROR', error: true })
    }
    this.disableButton = true
    const res = await this.rs.request({
      method: 'POST',
      endpoint: 'forgot_password',
      body: { email: this.loginForm.value.email },
    })

    this.emailError = false
    this.emailSent = this.loginForm.value.email

    if (res.error) {
      this.sent = false
      return this.gs.openAlert({ msg: 'PASSWORD_USER_INCORRECT', error: true })
    }

    this.disableButton = false
    this.sent = true
    this.blueSectionState = 'forgotPassword'
    this.gs.openAlert({ msg: 'RESET_PASS_REQUESTED' })
  }

  async getMagicLink() {
    if (this.loginForm.controls.email.invalid) {
      this.emailError = this.f.email.errors ? true : false
      return this.gs.openAlert({ msg: 'ERROR', error: true })
    }
    this.gs.logScreenEvents(
      'session_magic_link',
      'session_magic_link',
      'session_magic_link',
      'click',
    )
    this.disableButton = true

    const res = await this.rs.request({
      method: 'POST',
      endpoint: 'get_magic_link',
      body: { email: this.loginForm.value.email },
      type: 'web',
    })

    this.emailError = false

    this.emailSent = this.loginForm.value.email
    if (res.error) {
      this.disableButton = false
      this.sent = true
      this.blueSectionState = 'magicLink'
      return this.gs.openAlert({ msg: 'MAGIC_LINK_WRONG_EMAIL' })
    }

    this.disableButton = false
    this.sent = true
    this.loginState = 'magicLink'
    this.blueSectionState = 'magicLink'
    this.gs.openAlert({ msg: 'MAGIC_LINK_WRONG_EMAIL' })
  }
}
